import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ListaExtrasLayer from "../components/ListaExtrasLayer";
import { useTranslation } from "../i18n/I18nContext";

const ExtrasPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("extra.breadcrumb.list")} />
      <ListaExtrasLayer />
    </MasterLayout>
  );
};

export default ExtrasPage;
